import React from 'react'
import Svg from './Svg'
export const SvgWarning = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12S18.628 0 12 0zm1.976 18.545c0 .855-.699 1.551-1.552 1.551h-.611a1.552 1.552 0 01-1.548-1.551v-.613a1.55 1.55 0 011.548-1.547h.611c.853 0 1.552.696 1.552 1.547v.613zm-.444-4.75c0 .837-.519 1.528-1.145 1.528h-.538c-.629 0-1.142-.691-1.142-1.528L10 5.623c0-.944.772-1.718 1.716-1.718h.805c.944 0 1.718.775 1.718 1.718l-.707 8.172z" />
  </Svg>
))
SvgWarning.isIcon = true
export default SvgWarning
